import { useState, useEffect } from 'react';

interface GeolocationState {
  latitude: number;
  longitude: number;
  error: string | null;
  loading: boolean;
}

function useGeolocation(): GeolocationState {
  const [state, setState] = useState<GeolocationState>({
    latitude: 0,
    longitude: 0,
    error: null,
    loading: true,
  });

  function handleSuccess(position: GeolocationPosition) {
    setState({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      error: null,
      loading: false,
    });
  }

  function handleError(error: GeolocationPositionError) {
    setState(prev => ({
      ...prev,
      error: error.message,
      loading: false,
    }));
  }

  function effectCallback() {
    if (!navigator.geolocation) {
      setState(prev => ({
        ...prev,
        error: 'Geolocalização não suportada',
        loading: false,
      }));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      handleSuccess,
      handleError,
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  }

  useEffect(effectCallback, []);

  return state;
}

export { useGeolocation };